var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    staticStyle: {
      "margin-right": "80px"
    },
    attrs: {
      "label-width": "150px"
    }
  }, [_vm.form.id ? _c("el-form-item", {
    attrs: {
      label: "ID"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.id) + " ")]) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "服务器"
    }
  }, [_c("server-list", {
    attrs: {
      readCacheType: 1,
      type: 1
    },
    model: {
      value: _vm.form.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "server_id", $$v);
      },
      expression: "form.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "角色ID"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "支持多选（使用小写逗号间隔）"
    },
    model: {
      value: _vm.roleListStr,
      callback: function callback($$v) {
        _vm.roleListStr = $$v;
      },
      expression: "roleListStr"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "申请原因"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入申请原因"
    },
    model: {
      value: _vm.form.apply_reason,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "apply_reason", $$v);
      },
      expression: "form.apply_reason"
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.summit();
      }
    }
  }, [_vm._v("提交审核")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };